import { createActionConst } from '../../../utils/action.utils';

const QUARTALS_NAMESPACE = 'QUARTALS';

export const INITIAL_QUARTALS_PAGE = createActionConst(QUARTALS_NAMESPACE, 'INITIAL_QUARTALS_PAGE');
